export class PaymentTypeModel {
    UP: string[];
    CD: string[];
    WL: string[];
    NB: string[];
    constructor() {
        this.UP = [];
        this.CD = [];
        this.WL = [];
        this.NB = [];
    }
}